<script setup lang="ts">
import type { DirectSaleItemEntityWithPrice } from '~/types/directSale.type';

// PROPS
interface Props {
    directSale: DirectSaleItemEntityWithPrice;
}

const { directSale } = defineProps<Props>();

// MODEL
const offerAmount = defineModel<number>();

// COMPOSABLES
const { isSeller } = useDirectSaleStatus(toRef(() => directSale));
const { tt } = useTypedI18n();
</script>

<template>
    <template v-if="offerAmount !== undefined">
        <UFormField :label="tt('negotiation.yourOffer')" class="text-base">
            <SalePriceStepper
                v-model="offerAmount"
                :min-bid-step-amount="directSale.minNegotiationStepAmount"
                :max-bid-step-amount="directSale.maxNegotiationStepAmount"
                :min-bid-step-amount-threshold="directSale.minNegotiationStepAmountThreshold"
                :min-value="directSale.minNegotiationOffer"
                :max-value="directSale.buyNowPrice"
            />
        </UFormField>

        <DsdpSuccessProbabilityIndicator :offer-amount="offerAmount" :buy-now-price="directSale.buyNowPrice" />

        <SaleFees
            :is-buyer="!isSeller"
            :base-amount="offerAmount"
            :assets-count="directSale.assets.length"
            :fee-configuration="directSale.userMeta?.feeOverride"
            wrapper-class="text-left"
        />
    </template>
</template>
